import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Modal from 'react-modal';
import { Theme } from '../../config/theme';

const CLOSE_ICON = require('./close.svg');

export default class AcceptanceConditionsModal extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.props.toggle.bind(this);
  }

  render() {
    const Continue = () => (
      <button
        className={css(styles.continue)}
        onClick={() => { this.props.onClickPass(); }}
      >Continue</button>
    );

    return (
      <Modal
        isOpen={this.props.open}
        className={css(styles.container)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.67)',
            zIndex: 10,
            display: 'flex',
          },
        }}
        contentLabel="Report"
      >
        <div className={css(styles.modal_wrapper)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.title)}>Conditions Acceptance</h2>
            <div
              className={css(styles.close_icon)}
              onClick={this.props.toggle}
              role="button"
              tabIndex={0}
            >
              <img src={CLOSE_ICON} alt="Close modal" />
            </div>
          </div>
          <div className={css(styles.body)}>
            <p>By clicking continue, you have read the terms and conditions</p>
          </div>
          <div className={css(styles.actions)}>
            <Continue />
          </div>
        </div>
      </Modal>
    );
  }
}

AcceptanceConditionsModal.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  onClickPass: PropTypes.func.isRequired,
};

AcceptanceConditionsModal.defaultProps = {
  open: false,
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '95vw',
    maxHeight: '50vh',
    transform: 'translateY(40px)',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'auto',
    outline: 'none',
    margin: 'auto auto',
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    // height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 80px 40px',

    [Theme.mobile_query]: {
      padding: '0 30px 50px',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px',
  },
  title: {
    marginBottom: 0,
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: '900',
  },
  close_icon: {
    position: 'absolute',
    right: 5,
    top: 5,
    outline: 'none',
    cursor: 'pointer',
    padding: 10,
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',

    ':not(.a) > p': {
      marginBottom: 20,
      fontFamily: Theme.font_family_primary,
      fontSize: 16,
      color: '#828282',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 22,

    [Theme.mobile_query]: {
      marginTop: 0,
    },
  },
  continue: {
    width: 340,
    height: 50,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: Theme.primary,
    cursor: 'pointer',
    outline: 'none',
  },
});



// WEBPACK FOOTER //
// ./src/components/AcceptanceConditionsModal/index.js